import { render, staticRenderFns } from "./selectEnrollmentStudents.vue?vue&type=template&id=330284bf&scoped=true&"
import script from "./selectEnrollmentStudents.vue?vue&type=script&lang=js&"
export * from "./selectEnrollmentStudents.vue?vue&type=script&lang=js&"
import style0 from "./selectEnrollmentStudents.vue?vue&type=style&index=0&id=330284bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330284bf",
  null
  
)

export default component.exports